// Метка «у показателя есть прошлые замеры».
// Source: docs/specs/design-revision/b-home.md §2 (HEAL-75, изменение 1).
//
// Что было. На Главной метки не было вообще: понять, есть ли у показателя
// график, можно было только открыв его. Пятеро тестировщиков на этом
// споткнулись. В каталоге метка была, но в виде символа «~» в цветной
// пилюле — глиф, который прочитать невозможно.
//
// Плюс скрытый дефект, которого нет в тикете: условие показа было
// `hasHistory && !delta`, то есть у показателей с посчитанной динамикой —
// у самых интересных — метки не было вовсе.

import { ChartLine } from 'lucide-react';
import { cn } from '@/lib/utils';

export function HistoryHint({
  qualitative = false,
  className,
}: {
  /**
   * Результат словом («обнаружено» / «не обнаружено»). У таких показателей
   * история — ступенька между двумя словами, а не линия, поэтому «динамика»
   * обещала бы график, которого не будет (D-25).
   */
  qualitative?: boolean;
  className?: string;
}) {
  return (
    <span
      className={cn(
        // Нейтральный, не зелёный (D-4). Зелёный в нашей системе закреплён за
        // «в норме», и на красной карточке он читался бы как похвала.
        'mt-1 inline-flex items-center gap-1 text-hl-small font-semibold text-muted-foreground',
        className,
      )}
    >
      <ChartLine className="h-3.5 w-3.5 flex-shrink-0" aria-hidden="true" />
      {qualitative ? 'Есть история' : 'Есть динамика'}
    </span>
  );
}

/** Правило показа: история есть, только если замеров больше одного. */
export function hasHistory(pointsCount: number): boolean {
  return pointsCount > 1;
}
